<template>
  <div class="mb-6 cursor-pointer" @click="$emit('click')">
    <div class="flex justify-between items-center flex-nowrap mb-2.5">
      <p class="flex-1 flex items-center flex-nowrap">
        <span class="text-gray-700">{{ index + 1 }}.</span> <span class="ml-1">{{ title }}</span>
        <span class="ml-2 inline-block h-2 w-2 rounded-full bg-red-600"></span>
      </p>
      <img src="@/assets/icons/chevron-right.svg" class="w-4" alt="" />
    </div>
    <div class="bg-[#E5E5ED] h-1 rounded-full w-full relative">
      <div class="absolute bg-green-400 rounded-full h-1 top-0 bottom-0 left-0" :style="`width: ${stepProgress}%`"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: String,
  index: Number,
  percentDone: {
    type: Number,
    default: 0,
  },
  details: {
    type: Object,
  },
});

const stepProgress = computed(() => {
  const {
    candidate_name,
    candidate_email,
    candidate_phone,
    candidate_address,
    candidate_language,
    candidate_spoken_languages,
    candidate_honors_and_awards,
    candidate_courses_and_certifications,
    positions,
    education_qualifications,
    role_title,
    social_links,
    years_of_experience,
    skills,
    gender,
    availability_status,
    projects,
    state,
    country,
    timezone,
    desired_salary,
    desired_salary_currency,
    professional_title,
    company_categories,
    next_role_perks,
    job_types,
    work_type,
  } = props.details;
  let progress = 0;

  switch (props.index) {
    case 0:
      const aboutKeys = [candidate_name, candidate_phone, candidate_address, role_title, years_of_experience, state, country, timezone, gender];
      const aboutInc = Math.floor(100 / aboutKeys.length);
      aboutKeys.map((item) => {
        if (item) {
          if (typeof item == 'string') {
            progress += aboutInc;
          } else if (item.length) {
            progress += aboutInc;
          }
        }
      });
      break;
    case 1:
      if (positions.length) {
        const numOfPositions = positions.length <= 3 ? positions.length : 3;
        progress = Math.floor((numOfPositions / 3) * 100);
      }
      break;
    case 2:
      if (education_qualifications.length) {
        const numOfQuals = education_qualifications.length <= 3 ? education_qualifications.length : 3;
        progress = Math.floor((numOfQuals / 3) * 100);
      }
      break;
    case 3:
      if (skills.length) {
        const numOfSkills = skills.length <= 5 ? skills.length : 5;
        progress = Math.floor((numOfSkills / 5) * 100);
      }
      break;
    case 4:
      const preferenceKeys = [availability_status, professional_title, company_categories, next_role_perks, job_types, work_type];
      const preferenceInc = Math.floor(100 / preferenceKeys.length);
      preferenceKeys.map((item) => {
        if (item) {
          if (typeof item == 'string') {
            progress += preferenceInc;
          } else if (item.length) {
            progress += preferenceInc;
          }
        }
      });
      break;
    case 5:
      if (desired_salary) progress += 50;
      if (desired_salary_currency) progress += 50;
      break;
    case 6:
      if (projects.length) {
        const numOfProjs = projects.length <= 2 ? projects.length : 2;
        progress = Math.floor((numOfProjs / 2) * 100);
      }
      break;
    default:
      return progress;
  }

  return progress;
});
</script>
